import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';
import { mockData } from '../../mock';

const AssessmentCTASection = ({ onScrollToSection }) => {
  const { cta } = mockData;

  return (
    <section className="cta-section" data-testid="assessment-cta-section">
      <div className="container">
        <div className="cta-content">
          <h2 className="cta-title" data-testid="assessment-cta-title">
            {cta.title}
          </h2>
          <p className="cta-subtitle">{cta.subtitle}</p>
          <div className="cta-buttons">
            <Link to={cta.primaryActionLink} data-testid="assessment-cta-primary">
              <Button className="btn-cta">
                {cta.primaryAction}
                <ArrowRight className="ml-2" size={20} />
              </Button>
            </Link>
            <Button
              className="btn-secondary"
              onClick={() => onScrollToSection('programs')}
              data-testid="assessment-cta-secondary"
            >
              {cta.secondaryAction}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AssessmentCTASection;
